import React from 'react';
import { motion } from 'framer-motion';
import {
    Sun, Coffee, Bed, Utensils, Droplets, ShowerHead,
    Shirt, ListTodo, Sparkles, Train,
    Check
} from 'lucide-react';
import { useTranslation } from '../../../providers/TranslationProvider';

const Step2Habits = ({ data, onUpdate, isDarkMode }) => {
    const { t } = useTranslation();
    const selectedHabits = data.morningHabits || [];

    // Reduced list for compact view
    const habitsOptions = [
        { id: 'wakeup', label: t('onboarding.habits.wakeup'), icon: Sun },
        { id: 'prayer', label: t('onboarding.habits.prayer'), icon: Sparkles },
        { id: 'bed', label: t('onboarding.habits.bed'), icon: Bed },
        { id: 'water', label: t('onboarding.habits.water'), icon: Droplets },
        { id: 'shower', label: t('onboarding.habits.shower'), icon: ShowerHead },
        { id: 'coffee', label: t('onboarding.habits.coffee'), icon: Coffee },
        { id: 'breakfast', label: t('onboarding.habits.breakfast'), icon: Utensils },
        { id: 'plan', label: t('onboarding.habits.plan'), icon: ListTodo },
        { id: 'commute', label: t('onboarding.habits.commute'), icon: Train },
    ];

    const toggleHabit = (id) => {
        if (selectedHabits.includes(id)) {
            onUpdate({ morningHabits: selectedHabits.filter(item => item !== id) });
        } else {
            onUpdate({ morningHabits: [...selectedHabits, id] });
        }
    };

    return (
        <div className="w-full">
            <motion.div
                className="grid grid-cols-3 gap-2"
                initial="hidden"
                animate="visible"
                variants={{
                    visible: { transition: { staggerChildren: 0.03 } }
                }}
            >
                {habitsOptions.map((option) => {
                    const isSelected = selectedHabits.includes(option.id);
                    const Icon = option.icon;
                    return (
                        <motion.button
                            key={option.id}
                            variants={{
                                hidden: { opacity: 0, scale: 0.9 },
                                visible: { opacity: 1, scale: 1 }
                            }}
                            whileTap={{ scale: 0.95 }}
                            onClick={() => toggleHabit(option.id)}
                            className={`p-2.5 rounded-xl border flex flex-col items-center gap-1.5 transition-all duration-200 relative overflow-hidden backdrop-blur-md min-h-[80px] justify-center ${isSelected
                                ? 'border-blue-500 bg-blue-500/10'
                                : isDarkMode
                                    ? 'border-white/5 bg-white/5 hover:border-white/20'
                                    : 'border-slate-200 bg-white/50 hover:bg-slate-50'
                                }`}
                        >
                            <div className={`p-1.5 rounded-lg shrink-0 transition-colors duration-200 ${isSelected
                                ? 'bg-blue-500 text-white'
                                : isDarkMode ? 'bg-white/5 text-slate-400' : 'bg-slate-100 text-slate-500'
                                }`}>
                                <Icon size={16} />
                            </div>
                            <span className={`text-xs font-medium truncate w-full ${isSelected
                                ? 'text-blue-400'
                                : isDarkMode ? 'text-slate-300' : 'text-slate-700'
                                }`}>
                                {option.label}
                            </span>

                            {isSelected && (
                                <div className="absolute top-1 right-1 text-blue-500">
                                    <Check size={10} className="fill-current" />
                                </div>
                            )}
                        </motion.button>
                    );
                })}
            </motion.div>
        </div>
    );
};

export default Step2Habits;
